export default __webpack_public_path__ + "static/gdpr-2be0d181057ec1119903f44b6aca4fb8.svg";